<template>
  <BaseModal
    ref="modal"
    class="modal-note"
    v-bind="attributes"
    v-on="$listeners"
  >
    <BaseText
      v-if="markDescription"
      v-bind="markDescription"
      class="modal-note__mark"
    />
    <BaseText
      v-if="description"
      v-bind="description"
      class="modal-note__text"
    />
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseModal.vue';
import BaseText from '@/components/BaseText.vue';

export default {
  name: 'ModalNote',
  components: {
    BaseModal,
    BaseText,
  },
  computed: {
    attributes() {
      return {
        hasCloseButton: false,
        isMiddle: true,
        actions: [
          {
            text: this.$t('actions.close'),
            action: this.close,
          },
        ],
        ...this.$attrs,
      };
    },
    markDescription() {
      return {
        text: this.$t('texts.accountResolution'),
        theme: 'note',
      };
    },
    description() {
      return {
        text: this.$t('texts.accountDescription'),
        tag: 'p',
      };
    },
  },
  methods: {
    close() {
      return this.$refs.modal?.close();
    },
  },
};
</script>

<style lang="stylus">
.modal-note
  .modal__content
    width 50em

  &__mark
    margin -2em
    margin-bottom 2em
    padding 1.5em 2em
    border-radius inherit
</style>
